import { StyledMobileDisabled } from '@/shared/styles';
import { useTranslation } from 'react-i18next';

export const MobileDisabled: React.FC = () => {
  const { t } = useTranslation();
  return <StyledMobileDisabled>{t('mobile.accessible_from_desktop.button')}</StyledMobileDisabled>;
};
